var render = function render(){var _vm=this,_c=_vm._self._c;return _c('content-block',{attrs:{"title":"备件清单"}},[_c('TableWithPagination',{attrs:{"tableData":_vm.list,"row-key":"index","editConfig":{ trigger: 'munal', mode: 'cell' },"columnList":_vm.columnList,"size":"mini"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }